// Component-specific constants

// Internal application routes
export const APP_ROUTES = {
  DASHBOARD: '/',
  AUCTIONS: '/auctions',
  MARKET: '/market',
  INSTANT_BUY: '/instant-buy',
  ALL_CARDS: '/all',
  TOP_PLAYERS: '/top',
  NBA_TOP_PLAYERS: '/nba/top',
  PLAYER: '/player',
  NBA_PLAYER: '/nba/player',
  MANAGER: '/manager',
  SEARCH: '/search',
} as const;

// Manager-specific routes
export const MANAGER_ROUTES = {
  CARDS: '/cards',
  NBA_LINEUP: '/nba/lineup',
  REFRESH_CARDS: '/cards/refresh',
} as const;

// Default text messages
export const DEFAULT_MESSAGES = {
  NO_DATA: 'No data',
  NO_BID: 'No Bid',
  NO_BIDS: 'No bids',
  NO_CLUB_DATA: 'No club data',
  NO_LEAGUE_DATA: 'No league data',
  NO_CARDS_FOUND: 'No cards found',
  NO_PLAYERS_FOUND: 'No players found',
  UNKNOWN: 'Unknown',
  UNKNOWN_SCORES: 'Unknown Scores',
  NO_DATA_AVAILABLE: 'No data available',
  LOADING: 'Loading...',
  ALL_CLUBS: 'All Clubs',
  SEARCH_PLACEHOLDER: 'Search for players',
  SELECT_CLUB_PLACEHOLDER: 'Select a club',
} as const;

// Error messages
export const ERROR_MESSAGES = {
  LOADING_CLUBS: 'Error loading clubs data',
  LOADING_NBA_CLUBS: 'Error loading NBA clubs data',
  LOADING_LEAGUES: 'Error loading leagues data',
  LOADING_SEARCH: 'Error loading search data',
} as const;

// Component dimensions
export const COMPONENT_DIMENSIONS = {
  // Card dimensions
  CARD_WIDTH: 216,
  CARD_HEIGHT: 350,

  // Image dimensions
  CLUB_EMBLEM_WIDTH: 30,
  CLUB_EMBLEM_HEIGHT: 30,

  // Search modal dimensions
  SEARCH_MODAL_WIDTH: 472,

  // Chart dimensions
  CHART_WIDTH: 1000,
  CHART_HEIGHT: 300,
  CHART_STROKE_WIDTH: 2,

  // Score chart dimensions
  SCORE_CHART_FRAGMENT_WIDTH: 100,
  SCORE_CHART_STROKE_WIDTH: 5,
} as const;

// Menu configuration
export const MENU_CONFIG = {
  SUB_MENU_CLOSE_DELAY: 0.01,
} as const;

// Search configuration
export const SEARCH_CONFIG = {
  MIN_SEARCH_LENGTH: 3,
  SEARCH_DELAY: 500,
} as const;

// Apply/Reset filter action feedback
export const FILTER_ACTION_CONFIG = {
  // How long to wait for a fetch to start before giving up (unchanged filters and
  // fresh cache hits never trigger one).
  GRACE_DELAY: 500,
  // Hard cap so the indicator can never get stuck; a retrying request can outlive it.
  MAX_DELAY: 30_000,
} as const;

// Table pagination
export const TABLE_CONFIG = {
  PAGE_SIZE: 10,
} as const;

// Position text processing
export const POSITION_CONFIG = {
  NBA_PREFIX: 'NBA_',
  COMMA_SEPARATOR: ',',
  COMMA_WITH_SPACE: ', ',
} as const;

// External search URLs
export const EXTERNAL_SEARCH_URLS = {
  TRANSFERMARKT: 'https://www.transfermarkt.com/schnellsuche/ergebnis/schnellsuche?query=',
  GOOGLE_NEWS: 'https://www.google.com/search?q=',
  TWITTER: 'https://x.com/search?q=',
} as const;

// External search URL parameters
export const EXTERNAL_SEARCH_PARAMS = {
  GOOGLE_NEWS_SUFFIX: '&tbm=nws',
  TWITTER_SUFFIX: '&src=typed_query',
} as const;

// Fallback image constants for ProgressiveImage components
export const FALLBACK_IMAGES = {
  CARD: '/images/placeholder-card.svg',
  CLUB: '/images/placeholder-club.svg',
  GENERIC: '/images/placeholder-generic.svg',
} as const;
